import React, { useMemo } from 'react';
import {
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  CircularProgress,
  LinearProgress,
} from '@mui/material';
import CustomDataEntrySection from './CustomDataEntrySection';

const CustomSectionsBehaviorWrapper = ({
  dataPoint,
  index,
  quicktrackInfo,
  user,
  allCustomSections = [],
  isLoadingCustomSections = false,
  handleCustomSectionCheckboxChange,
  handleCustomSectionAnswerChange,
}) => {
  // Filter custom sections based on the IDs stored in the behavior
  const selectedCustomSections = useMemo(() => {
    // Check multiple possible locations for CustomDataEntrySections
    const customDataEntrySections =
      quicktrackInfo?.DataEntrySelection?.CustomDataEntrySections ||
      quicktrackInfo?.DataCollection?.DataEntrySelection
        ?.CustomDataEntrySections ||
      [];

    if (
      !allCustomSections ||
      !customDataEntrySections ||
      customDataEntrySections.length === 0
    ) {
      return [];
    }

    const filtered = allCustomSections.filter((section) =>
      customDataEntrySections.includes(section.docId)
    );

    return filtered;
  }, [allCustomSections, quicktrackInfo]);

  const hasCustomSectionsConfigured =
    quicktrackInfo?.DataEntrySelection?.CustomDataEntrySections?.length > 0 ||
    quicktrackInfo?.info?.DataEntrySelection?.CustomDataEntrySections?.length >
      0 ||
    quicktrackInfo?.DataCollection?.DataEntrySelection?.CustomDataEntrySections
      ?.length > 0;

  return (
    <>
      {isLoadingCustomSections && hasCustomSectionsConfigured && (
        <Box sx={{ mt: 2, p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <CircularProgress size={16} />
            <Typography variant='body2' color='text.secondary'>
              Loading custom sections...
            </Typography>
          </Box>
          <LinearProgress
            sx={{
              height: 2,
              mb: 2,
              backgroundColor: '#e0e0e0',
              '& .MuiLinearProgress-bar': { backgroundColor: '#9291ef' },
            }}
          />

          {[1, 2].map((item) => (
            <Box
              key={item}
              sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}
            >
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  backgroundColor: '#e0e0e0',
                  borderRadius: '2px',
                }}
              />
              <Box
                sx={{
                  width: 120,
                  height: 16,
                  backgroundColor: '#e0e0e0',
                  borderRadius: '2px',
                }}
              />
            </Box>
          ))}
        </Box>
      )}

      {!isLoadingCustomSections &&
        selectedCustomSections.map((section) => {
          const sectionTitle =
            section.dataEntrySections?.title || 'Custom Section';

          const label = `Add ${sectionTitle}`;
          const value = section.docId;

          return (
            <Box
              key={section.docId}
              sx={{ display: 'flex', flexDirection: 'column' }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={dataPoint.selectedOptions.includes(value)}
                    onChange={(e) =>
                      handleCustomSectionCheckboxChange(index, e)
                    }
                    value={value}
                  />
                }
                label={label}
              />
              {dataPoint.selectedOptions.includes(value) && (
                <Box sx={{ ml: 3, pl: 2, borderLeft: '2px solid #e0e0e0' }}>
                  <CustomDataEntrySection
                    allSelectedSectionIds={dataPoint.selectedOptions}
                    sectionDocId={section.docId}
                    customSectionAnswers={dataPoint.customSection}
                    onCustomSectionChange={handleCustomSectionAnswerChange}
                    user={user}
                    dataPoint={dataPoint}
                    dataPointIndex={index}
                    timeOfCollectionType={
                      quicktrackInfo?.DataEntrySelection?.TimeOfCollectionType
                    }
                    timeOfCollectionSpecificsList={
                      quicktrackInfo?.DataEntrySelection
                        ?.TimeOfCollectionSpecificsList || []
                    }
                  />
                </Box>
              )}
            </Box>
          );
        })}
    </>
  );
};

export default CustomSectionsBehaviorWrapper;
